var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("form-select", {
        staticClass: "mt-4",
        attrs: {
          label: "Available Dates",
          name: "event_date",
          id: "event_date",
          options: _vm.event.dates,
          "display-by": "formatted_start_date",
          "track-as-integer": true,
          bold: true,
        },
        model: {
          value: _vm.form.date,
          callback: function ($$v) {
            _vm.$set(_vm.form, "date", $$v)
          },
          expression: "form.date",
        },
      }),
      _vm._v(" "),
      !_vm.dateIsClosed
        ? _c("available-seats", {
            attrs: {
              total: _vm.availableSeats.total,
              member: _vm.availableSeats.member,
            },
          })
        : _c(
            "span",
            {
              staticClass:
                "inline-flex mt-1 w-full justify-center items-center px-2.5 py-1 rounded-md text-sm font-medium leading-5 bg-red-500 text-white transition-colors duration-300",
            },
            [
              _c("span", { staticClass: "block text-center" }, [
                _vm._v("\n            Event Closed For Bookings\n        "),
              ]),
            ]
          ),
      _vm._v(" "),
      _vm.availableSeats.total > 0 || _vm.dateIsClosed
        ? _c(
            "div",
            [
              _c("form-select", {
                staticClass: "mt-3",
                attrs: {
                  label: "How many Seats",
                  name: "seats",
                  id: "seats",
                  options: _vm.seatOptions,
                  "track-as-integer": true,
                  bold: true,
                  disabled: _vm.availableSeats.total === 0 || _vm.dateIsClosed,
                },
                model: {
                  value: _vm.form.seats,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "seats", $$v)
                  },
                  expression: "form.seats",
                },
              }),
              _vm._v(" "),
              _c(
                "form-button",
                {
                  staticClass: "mt-4",
                  attrs: {
                    disabled:
                      _vm.availableSeats.total === 0 || _vm.dateIsClosed,
                  },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.showOrAdd.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n            Book Now\n        ")]
              ),
            ],
            1
          )
        : _c("div", [
            _vm.initialised
              ? _c(
                  "div",
                  [
                    _c("event-waiting-list", {
                      attrs: {
                        "event-date-id": _vm.form.date,
                        "event-name": _vm.event.name,
                        "event-date": _vm.selectedDate.start_date_no_time,
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
      _vm._v(" "),
      _c(
        "portal",
        { attrs: { to: "slideover" } },
        [
          _vm.showAddOns
            ? _c(
                "slide-over",
                {
                  attrs: { heading: "Event Add-ons" },
                  on: {
                    hide: function ($event) {
                      _vm.showAddOns = false
                      _vm.initialiseFormData()
                    },
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "footer",
                        fn: function (slotProps) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "flex-shrink-0 px-4 py-4 sm:space-x-4 flex flex-col-reverse sm:flex-row sm:justify-end",
                              },
                              [
                                _c(
                                  "form-button",
                                  {
                                    staticClass: "w-full sm:w-auto",
                                    attrs: { colour: "gray" },
                                    nativeOn: {
                                      click: function ($event) {
                                        return slotProps.hide()
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        Cancel\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "form-button",
                                  {
                                    staticClass: "w-full sm:w-auto",
                                    nativeOn: {
                                      click: function ($event) {
                                        _vm.addToBasket(slotProps.hide())
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        Add to Basket\n                    "
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2298183160
                  ),
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col justify-between min-h-full px-4 sm:px-6",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "divide-y divide-gray-200" },
                        _vm._l(_vm.addOns, function (addon, index) {
                          return _c(
                            "div",
                            { staticClass: "py-4" },
                            [
                              _c("div", { staticClass: "flex items-center" }, [
                                _c("h3", {
                                  staticClass: "mb-1 mr-1",
                                  domProps: { innerHTML: _vm._s(addon.name) },
                                }),
                                _vm._v(" "),
                                addon.description
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "-mt-2",
                                        on: {
                                          click: function ($event) {
                                            _vm.modal.heading = addon.name
                                            _vm.modal.description =
                                              addon.description
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticClass:
                                              "w-5 h-5 hover:text-primary-600",
                                            attrs: {
                                              fill: "none",
                                              stroke: "currentColor",
                                              viewBox: "0 0 24 24",
                                              xmlns:
                                                "http://www.w3.org/2000/svg",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                "stroke-linecap": "round",
                                                "stroke-linejoin": "round",
                                                "stroke-width": "2",
                                                d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]),
                              _vm._v(" "),
                              addon.applies_to_group
                                ? _c("form-select", {
                                    staticClass: "mt-2",
                                    attrs: {
                                      options: addon.options,
                                      "track-as-integer": true,
                                    },
                                    model: {
                                      value: _vm.form.addOns[index].value,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form.addOns[index],
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "form.addOns[index].value",
                                    },
                                  })
                                : _c("form-multi-add-on", {
                                    staticClass: "mt-2",
                                    attrs: {
                                      options: addon.options,
                                      "group-max": _vm.form.seats,
                                    },
                                    model: {
                                      value: _vm.form.addOns[index].value,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.form.addOns[index],
                                          "value",
                                          $$v
                                        )
                                      },
                                      expression: "form.addOns[index].value",
                                    },
                                  }),
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "border-t border-gray-200 -mx-4 sm:-mx-6 py-4 px-4 sm:px-6",
                        },
                        [
                          _c("h3", { staticClass: "mb-1" }, [
                            _vm._v("Booking Summary"),
                          ]),
                          _vm._v(" "),
                          _c("booking-summary", {
                            attrs: {
                              event: _vm.event,
                              seats: _vm.form.seats,
                              "selected-add-ons": _vm.form.addOns,
                              "add-on-options": _vm.addOnOptions,
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "portal",
        { attrs: { to: "modal" } },
        [
          _vm.modal.heading
            ? _c("modal", {
                on: {
                  hide: function ($event) {
                    _vm.modal.heading = ""
                    _vm.modal.description = ""
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (props) {
                        return [
                          _c("h3", {
                            staticClass: "mb-1",
                            domProps: { innerHTML: _vm._s(_vm.modal.heading) },
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "text-gray-600 space-y-3",
                            domProps: {
                              innerHTML: _vm._s(_vm.modal.description),
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "flex justify-end -mb-2 sm:-mb-4" },
                            [
                              _c(
                                "form-button",
                                {
                                  attrs: { color: "gray" },
                                  nativeOn: {
                                    click: function ($event) {
                                      return props.hide.apply(null, arguments)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        Close\n                    "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  1110388912
                ),
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }